/**
 * 应用类型
 */
export enum ApplicationType {
  /**
   * 后台管理
   */
  OPERATION = 0,

  /**
   * 会员中心
   */
  MEMBER = 1,
  /**
   * 商城
   */
  MALL = 2
}
